import React from "react";
import { useParams, useLocation } from "react-router-dom";
import querystring from "query-string";

import SearchIconsResults from "icons/SearchIconsResults";
import SearchCollectionsResults from "icons/SearchCollectionsResults";
import SearchSegmentedControlButtons from "./SearchSegmentedControlButtons";

import { SEARCH_TYPES } from "./helpers";

const SearchPage = () => {
    const { searchType } = useParams();
    const location = useLocation();
    const { q: query } = querystring.parse(location.search);

    return (
        <>
            <SearchSegmentedControlButtons
                query={query}
                activeSearchType={searchType}
            />
            <SearchIconsResults
                query={query}
                isActive={searchType === SEARCH_TYPES.ICONS}
            />
            <SearchCollectionsResults
                query={query}
                isActive={searchType === SEARCH_TYPES.ICON_COLLECTIONS}
            />
        </>
    );
};

export default SearchPage;
